document.addEventListener("DOMContentLoaded", function () {
  const slideInItems = document.querySelectorAll(".slide-up-animated");
  if (!slideInItems) return;
  slideInItems.forEach((item) => {
    item.classList.add("animation-start");
  });
});
function getSliderSettings() {
  return {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
}

function getSubSliderProductSettings() {
  return {
    slidesPerView: "auto",
    direction: "vertical",
    navigation: false,
  };
}

const sliderInit = (isUpdate = false, container = null) => {
  const scope = container || document;
  const sliders = container
    ? scope.querySelectorAll(".js-media-list")
    : scope.querySelectorAll(".product-section .js-media-list");

  sliders.forEach((sliderElement) => {
    const productSection = sliderElement.closest(".product-section");
    const mediaListWrapper = sliderElement.closest(
      ".product__media-list-wrapper"
    );
    const mediaListContainer = sliderElement.closest(".product__media-list");
    const sliderScope =
      mediaListContainer || mediaListWrapper || sliderElement.parentElement;
    const thumbsSwiperElement =
      mediaListWrapper?.querySelector(".js-media-sublist") ||
      mediaListContainer?.querySelector(".js-media-sublist") ||
      productSection?.querySelector(".js-media-sublist") ||
      sliderScope?.querySelector(".js-media-sublist");

    // 🔥 DESTROY OLD INSTANCES (safe re-init)
    sliderElement.swiper?.destroy(true, true);
    thumbsSwiperElement?.swiper?.destroy(true, true);

    sliderElement.classList.remove(
      "swiper-initialized",
      "swiper-backface-hidden"
    );

    thumbsSwiperElement?.classList.remove(
      "swiper-initialized",
      "swiper-backface-hidden"
    );

    // 🔥 THUMBS SWIPER
    const thumbsSwiper = thumbsSwiperElement
      ? new Swiper(thumbsSwiperElement, {
          centeredSlides: true,
          centeredSlidesBounds: true,
          slideToClickedSlide: true,
          spaceBetween: 8,
          direction: "horizontal",
          slidesPerView: "auto",
          watchSlidesProgress: true,
          breakpoints: {
            990: {
              direction: "vertical",
              slidesPerView: 7,
              spaceBetween: 16,
            },
          },
        })
      : null;

    // 🔥 MAIN SWIPER
    const slider = new Swiper(sliderElement, {
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 4,

      navigation: {
        nextEl:
          mediaListContainer?.querySelector(".swiper-btn--next") ||
          productSection?.querySelector(".swiper-btn--next") ||
          sliderScope?.querySelector(".swiper-btn--next"),
        prevEl:
          mediaListContainer?.querySelector(".swiper-btn--prev") ||
          productSection?.querySelector(".swiper-btn--prev") ||
          sliderScope?.querySelector(".swiper-btn--prev"),
      },

      thumbs: {
        swiper: thumbsSwiper,
      },

      on: {
        slideChangeTransitionStart: function () {
          if (thumbsSwiperElement?.swiper) {
            thumbsSwiperElement.swiper.slideTo(this.activeIndex);
          } else {
            thumbsSwiper?.slideTo(this.activeIndex);
          }
        },

        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
        },

        slideChangeTransitionEnd: function () {
          const modelViewer =
            this.slides[this.activeIndex]?.querySelector("model-viewer");

          if (modelViewer) {
            modelViewer
              .querySelector(".shopify-model-viewer-ui__button--poster")
              ?.[
                window.getComputedStyle(modelViewer).display === "none"
                  ? "setAttribute"
                  : "removeAttribute"
              ]("hidden", "");
          }
        },

        touchStart: function () {
          const modelViewer =
            this.slides[this.activeIndex]?.querySelector("model-viewer");

          if (
            modelViewer &&
            !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")
          ) {
            this.params.noSwiping = true;
            this.params.noSwipingClass = "swiper-slide";
          }
        },
      },
    });

    // 🔥 REAL-TIME VISUAL CALCULATOR (With Explicit URL Variant Matching)
    const syncToActiveVariant = () => {
      const allSlides = Array.from(
        sliderElement.querySelectorAll(".swiper-slide")
      );
      let targetIndex = -1;

      // 1. STRATEGIC FIX: Sync directly with the active variant ID from the URL string
      const urlParams = new URLSearchParams(window.location.search);
      const currentVariantId = urlParams.get("variant");

      if (currentVariantId) {
        targetIndex = allSlides.findIndex((slide) => {
          // Looks for matching data attribute (e.g., data-variant-id="47378568446197")
          return slide.getAttribute("data-variant-id") === currentVariantId;
        });
      }

      // 2. Fallback: Check if the theme updated class lists first
      if (targetIndex === -1) {
        targetIndex = allSlides.findIndex((slide) => {
          return (
            slide.classList.contains("is-active") ||
            slide.classList.contains("active") ||
            slide.classList.contains("selected")
          );
        });
      }

      // 3. Fallback: Find the first slide with a physically visible image item
      if (targetIndex === -1) {
        targetIndex = allSlides.findIndex((slide) => {
          const img = slide.querySelector("img");
          if (!img) return false;

          const style = window.getComputedStyle(slide);
          return (
            style.display !== "none" &&
            style.visibility !== "hidden" &&
            !slide.hasAttribute("aria-hidden")
          );
        });
      }

      // If a valid visual item is found, snap directly to it (0ms jump duration)
      if (targetIndex > -1) {
        slider.slideTo(targetIndex, 0);
        thumbsSwiper?.slideTo(targetIndex, 0);
      }
    };

    // 🔥 SAFE UPDATE AFTER RENDER
    requestAnimationFrame(() => {
      thumbsSwiper?.update();
      slider.update();
      syncToActiveVariant();
    });

    // Handle asynchronous section updates (triggered on product selection changes)
    if (isUpdate) {
      setTimeout(() => {
        thumbsSwiper?.update();
        slider.update();
        syncToActiveVariant();
      }, 350); // Gives AJAX element swaps a comfortable execution window
    }
  });
};

const quickSliderInit = (isUpdate = false, container = null) => {
  const scope = container || document;
  const quickSliders = container
    ? scope.querySelectorAll(".quick-product__media-list .quick-js-media-list")
    : scope.querySelectorAll(
        ".product-section .quick-product__media-list .quick-js-media-list"
      );

  quickSliders.forEach((sliderElement) => {
    const container = sliderElement.closest(".quick-product__media-list");
    if (!container) return;

    sliderElement.swiper?.destroy(true, true);

    const slider = new Swiper(sliderElement, {
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl: container.querySelector(".swiper-btn--next"),
        prevEl: container.querySelector(".swiper-btn--prev"),
      },
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        type: "fraction",
        formatFractionCurrent: (number) => `0${number}`.slice(-2),
        formatFractionTotal: (number) => `0${number}`.slice(-2),
      },
      on: {
        slideChange: function () {
          window.pauseAllMedia();
        },
      },
    });

    if (isUpdate) {
      setTimeout(() => {
        slider.update();
      }, 350);
    }
  });
};

const subSliderInit = (isUpdate) => {
  const subSliders = document.querySelectorAll(
    ".product-section .js-media-sublist"
  );
  subSliders.forEach((subSliderElement) => {
    const mainSliderElement = subSliderElement
      .closest(".product-section")
      .querySelector(".js-media-list");

    let subSlider = new Swiper(subSliderElement, {
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesPerView: 3,
      spaceBetween: 8,
      direction: "horizontal",
      navigation: false,
      freeMode: false,
      watchSlidesProgress: true,
      on: {
        touchEnd: function (s) {
          const range = 5;
          const diff = s.isHorizontal()
            ? s.touches.currentX - s.touches.startX
            : s.touches.currentY - s.touches.startY;
          if (Math.abs(diff) < range) {
            s.allowClick = true;
          }
        },
      },
      transitionStart: function () {
        if (mainSliderElement) {
          mainSliderElement.swiper.slideTo(this.activeIndex);
        }
      },
      breakpoints: {
        990: {
          direction: "vertical",
          slidesPerView: 7,
          spaceBetween: 16,
        },
      },
    });

    if (isUpdate) {
      setTimeout(() => {
        subSlider.update();
      }, 800);
    }
  });
};

const scrollSliderInit = (isUpdate) => {
  const sliderContainer = document.querySelector(
    ".product-section .product__media--scroll"
  );
  let isSliderHovered = false;
  let isAtEndOfSlider = false;

  if (sliderContainer) {
    let slider = new Swiper(sliderContainer, {
      direction: "vertical",
      slidesPerView: 1,
      autoHeight: false,
      keyboard: true,
      spaceBetween: 0,
      mousewheel: true,
      navigation: {
        nextEl: ".swiper-btn--next",
        prevEl: ".swiper-btn--prev",
      },
      pagination: {
        el: `.swiper-pagination`,
        type: "fraction",
        formatFractionCurrent: (number) => `0${number}`.slice(-2),
        formatFractionTotal: (number) => `0${number}`.slice(-2),
      },
      on: {
        init: function () {
          const innerHeight = window.innerHeight - 160;
          sliderContainer.style.height = `${innerHeight}px`;
          this.slides.forEach((slide) => {
            slide.style.height = `${window.innerHeight}px`;
          });
        },
        reachEnd: () => {
          isAtEndOfSlider = true;
        },
        slideChange: () => {
          isAtEndOfSlider = false;
        },
      },
    });

    const preventPageScroll = (e) => {
      if (isSliderHovered && !isAtEndOfSlider) {
        e.preventDefault();
      }
    };

    sliderContainer.addEventListener("mouseenter", () => {
      isSliderHovered = true;
    });

    sliderContainer.addEventListener("mouseleave", () => {
      isSliderHovered = false;
    });

    window.addEventListener(
      "wheel",
      (e) => {
        if (isSliderHovered && !isAtEndOfSlider) {
          preventPageScroll(e);
          slider.mousewheel.enable();
        } else {
          slider.mousewheel.disable();
        }
      },
      { passive: false }
    );

    if (isUpdate) {
      setTimeout(() => {
        slider.update();
      }, 800);
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  scrollSliderInit();
  document.addEventListener("shopify:section:load", function () {
    scrollSliderInit(true);
  });
});

const sliderHorizontalInit = (isUpdate) => {
  const horizontalSlider = document.querySelector(
    ".product-section .product__media-list-wrapper-horizontal .js-media-list-horizontal"
  );
  const secondarySlider = document.querySelector(
    ".product-section .product__media-list-wrapper-horizontal.secondary .js-media-list-horizontal"
  );
  let carousel = horizontalSlider
    ? horizontalSlider.querySelectorAll(".swiper-wrapper")
    : [];

  // Destroy existing sliders if updating
  if (isUpdate) {
    if (horizontalSlider && horizontalSlider.swiper) {
      horizontalSlider.swiper.destroy(true, true);
    }
    if (secondarySlider && secondarySlider.swiper) {
      secondarySlider.swiper.destroy(true, true);
    }
  }

  let slider2;
  let slider1;
  if (secondarySlider) {
    slider2 = new Swiper(secondarySlider, {
      slidesPerView: 1,
      //slidesOffsetAfter: 400,
      //slidesOffsetBefore: 400,
      //loop: true,
      //initialSlide: 3,
      autoHeight: true,
      spaceBetween: 0,
      on: {
        slideChange: function () {
          window.pauseAllMedia();
        },
      },
    });

    if (isUpdate) {
      setTimeout(() => {
        slider2.update();
      }, 800);
    }
  }

  if (
    horizontalSlider &&
    horizontalSlider.querySelectorAll(".swiper-slide").length > 1
  ) {
    slider1 = new Swiper(horizontalSlider, {
      slidesPerView: 1.2,
      //loop: true,
      autoHeight: true,
      spaceBetween: 16,
      slidesOffsetAfter: 80,
      breakpoints: {
        990: {
          slidesPerView: 1.4,
        },
        1150: {
          slidesPerView: 1.6,
        },
        1360: {
          slidesPerView: 2,
        },
      },
      controller: { control: slider2 },
      navigation: {
        nextEl: ".swiper-horizontal-btn-next",
        prevEl: ".swiper-horizontal-btn-prev",
      },
      on: {
        slideChange: function () {
          window.pauseAllMedia();
        },
      },
    });

    if (isUpdate) {
      setTimeout(() => {
        slider1.update();
      }, 800);
    }
  }
  if (horizontalSlider && secondarySlider) {
    slider1.controller.control = slider2;
    slider2.controller.control = slider1;
  }
};

document.addEventListener("DOMContentLoaded", function () {
  sliderHorizontalInit();
  document.addEventListener("shopify:section:load", function () {
    sliderHorizontalInit(true);
  });
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector(".quantity__input");
    if (!this.input) return;

    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.input.addEventListener("paste", this.onInputChange.bind(this));
    this.input.addEventListener("input", this.onInputChange.bind(this));
    this.input.addEventListener("focusout", this.onFocusout.bind(this));

    this.updateButtonStates();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
    this.updateButtonStates();
  }

  onInputChange(e) {
    const numberRegex = /^0*?[1-9]\d*$/;
    if (!numberRegex.test(e.currentTarget.value) && e.currentTarget.value !== "") {
      e.currentTarget.value = 1;
    }
    this.updateButtonStates();
  }

  onFocusout(e) {
    if (e.currentTarget.value === "") {
      e.currentTarget.value = this.getMin() || 1;
      this.updateButtonStates();
      return;
    }
    this.validateAndClamp();
    this.updateButtonStates();
  }

  getMin() {
    const raw = this.input.getAttribute("min");
    return raw !== null ? parseInt(raw) : 1;
  }

  getMax() {
    const raw = this.input.getAttribute("max");
    return raw !== null ? parseInt(raw) : null;
  }

  getStep() {
    const raw = this.input.getAttribute("step");
    return raw ? parseInt(raw) : 1;
  }

  updateButtonStates() {
    if (!this.input) return;
    const value = parseInt(this.input.value);
    const min = this.getMin();
    const max = this.getMax();

    const minusBtn = this.querySelector('[name="minus"]');
    const plusBtn = this.querySelector('[name="plus"]');

    if (minusBtn) {
      minusBtn.disabled = !isNaN(value) && value <= min;
    }
    if (plusBtn) {
      plusBtn.disabled = max !== null && !isNaN(value) && value >= max;
    }
  }

  validateAndClamp() {
    if (!this.input) return;
    const value = parseInt(this.input.value);
    const step = this.getStep();
    const min = this.getMin();
    const max = this.getMax();

    if (isNaN(value)) return;

    let clamped = value;
    let messageKey = "";

    if (value < min) {
      clamped = min;
      messageKey = "min_error";
    } else if (max !== null && value > max) {
      clamped = max;
      messageKey = "max_error";
    } else if (step > 1 && value % step !== 0) {
      const rounded = Math.round(value / step) * step;
      clamped = max !== null ? Math.min(rounded, max) : rounded;
      clamped = Math.max(clamped, min);
      messageKey = "step_error";
    }

    if (clamped !== value) {
      this.input.value = clamped;
    }

    if (messageKey && window.cartStrings?.[messageKey]) {
      const msg = window.cartStrings[messageKey]
        .replace("[min]", min)
        .replace("[max]", max)
        .replace("[step]", step);
      this.showValidationMessage(msg);
    } else {
      this.clearValidationMessage();
    }
  }

  getErrorEl() {
    let el = this.querySelector(".quantity__error-message");
    if (el) return el;
    el = document.createElement("p");
    el.className = "quantity__error-message";
    el.setAttribute("aria-live", "polite");
    el.setAttribute("role", "status");
    this.appendChild(el);
    return el;
  }

  showValidationMessage(msg) {
    const el = this.getErrorEl();
    el.textContent = msg;
    clearTimeout(this._msgTimer);
    this._msgTimer = setTimeout(() => this.clearValidationMessage(), 3000);
  }

  clearValidationMessage() {
    clearTimeout(this._msgTimer);
    const el = this.querySelector(".quantity__error-message");
    if (el) el.textContent = "";
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      // Safari mobile fix: Don't close drawer when clicking theme toggle
      if (button.classList.contains("header__toggle-scheme")) return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.header =
        this.header || document.querySelector(".shopify-section-header");
      this.header.classList.remove("color-background-1");
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const toggleSchemeElement = this.querySelector(".header__toggle-scheme");
    if (
      toggleSchemeElement &&
      toggleSchemeElement.contains(document.activeElement)
    ) {
      return;
    }

    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      this.header.classList.add("color-background-1");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class accountModal extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#accountModal-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    this.querySelector("#account-modal-close").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.initResizeListener();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#account-icon-open");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("account-modal");
        const focusElement =
          this.querySelector(".account__main") ||
          this.querySelector(".account__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  initResizeListener() {
    window.addEventListener("resize", () => {
      const isDesktop = window.innerWidth >= 750;
      if (isDesktop && this.classList.contains("active")) {
        this.close();
      }
    });
  }
}

customElements.define("account-modal", accountModal);

class BurgerDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#BurgerDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    //this.querySelector("#burger-drawer-close").addEventListener(
    //	"click",
    //	this.close.bind(this)
    //);
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#burger-icon-bubble");
    const cartClose = document.querySelector("#burger-drawer-close");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    cartClose.addEventListener("click", (event) => {
      event.preventDefault();
      this.close(cartLink);
    });
    cartClose.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.close(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    //this.addEventListener(
    //	"transitionend",
    //	() => {
    //		const containerToTrapFocusOn = document.getElementById("BurgerDrawer");
    //		const focusElement =
    //			this.querySelector(".drawer__inner") ||
    //			this.querySelector(".burger__close");
    //		trapFocus(containerToTrapFocusOn, focusElement);
    //	},
    //	{ once: true }
    //);
    const cartLink = document.querySelector("#burger-icon-bubble");
    const cartClose = document.querySelector("#burger-drawer-close");
    cartLink.style.display = "none";
    cartClose.style.display = "block";

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.querySelectorAll(".drawer__accordion-title").forEach((btn) =>
      btn.classList.remove("active")
    );
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);

    const cartLink = document.querySelector("#burger-icon-bubble");
    const cartClose = document.querySelector("#burger-drawer-close");
    cartClose.style.display = "none";
    cartLink.style.display = "block";
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("burger-drawer", BurgerDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    const overlay = this.querySelector("#ModalClose-Overlay");
    if (overlay) {
      overlay.addEventListener("click", this.hide.bind(this, false));
    }
    this.onEscapeKeyup = (event) => {
      if (event.code.toUpperCase() === "ESCAPE" && this.hasAttribute("open")) this.hide();
    };
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    const dialog = this.querySelector('[role="dialog"]');
    trapFocus(this, dialog);
    const focusDialog = () => {
      if (this.hasAttribute("open") && !this.contains(document.activeElement)) dialog.focus();
    };
    requestAnimationFrame(focusDialog);
    dialog.addEventListener("transitionend", focusDialog, { once: true });
    document.addEventListener("keyup", this.onEscapeKeyup);
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    document.removeEventListener("keyup", this.onEscapeKeyup);
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.getAttribute("data-autoplay")) {
              let playPromise = entry.target.play();
              if (playPromise !== undefined) {
                playPromise.then((_) => {}).catch((error) => {});
              }
            }
          } else {
            entry.target.pause();
          }
        });
      });
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (
        deferredElement.nodeName == "VIDEO" ||
        deferredElement.nodeName == "IFRAME"
      ) {
        // force autoplay for safari

        if (this.classList.contains("video-section__media")) {
          let playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
          }
          videoObserver.observe(deferredElement);
        } else {
          deferredElement.play();
        }
      }
      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
              this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    this.sliderItems = this.querySelectorAll(".slider__slide");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
  }

  getScopedContainer() {
    return (
      this.closest("quick-add-modal") ||
      this.closest(".recommended-products") ||
      this.closest(".featured-product") ||
      this.closest("section") ||
      document
    );
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;
    if (this._syncingFromCounterpart) return;

    const clickedElement =
      event.target.closest("[data-product-url]") || event.target;
    this.combinedProductURL = clickedElement.dataset?.productUrl || null;
    const combinedProductURL = event.target.dataset?.productUrl;

    this.updateOptions();
    // updateMasterId method updates currentVariant from liquid <script data-all-variations-no-high>
    this.updateMasterId();
    this.toggleAddButton(true, "");

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    // -----
    // checking for high-variant and combined products
    // if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }
    // -----

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (
        this.currentVariant?.featured_media &&
        this.dataset?.variantMediaDisplay === "show_all"
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        this.updateMedia(mediaId);
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia(mediaId = null) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const targetMediaId =
      mediaId ||
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`;

    const scopedContainer = this.getScopedContainer();

    const newMediaGlobal = scopedContainer.querySelector(
      `[data-media-id="${targetMediaId}"]`
    );

    if (!newMediaGlobal) return;

    const parent = newMediaGlobal.parentElement;

    /**
     * ------------------------------------------------
     * Main sliders
     * ------------------------------------------------
     */

    const swiperWrappers = scopedContainer.querySelectorAll(
      ".product__media-wrapper, .global-variant-slider"
    );

    swiperWrappers.forEach((elem) => {
      // skip quickview here
      if (
        elem.firstElementChild &&
        elem.firstElementChild.classList.contains("quick-product__media-list")
      ) {
        return;
      }

      if (this.isHidden(elem)) return;

      const newMedia = elem.querySelector(`[data-media-id="${targetMediaId}"]`);

      if (!newMedia) return;

      const mediaList = elem.querySelector(
        ".js-media-list, .global-variant-js-media-list"
      );

      /**
       * Swiper layouts
       */
      if (mediaList && mediaList.swiper) {
        let slideIndex = mediaList.swiper.slides.findIndex((slideEl) => {
          return slideEl.dataset?.mediaId === targetMediaId;
        });

        // fallback
        if (slideIndex === -1) {
          slideIndex = Number(newMedia.dataset?.swiperSlideIndex || 0);
        }

        mediaList.swiper.slideTo(slideIndex, 800);
      } else {
        /**
         * Non-swiper layouts
         */
        newMedia && parent.prepend(newMedia);

        window.setTimeout(() => {
          parent.scroll(0, 0);
        });
      }

      /**
       * stacked / stacked_previews support
       */
      const stackedList =
        elem.querySelector(
          ".product__media-list[data-desktop-type='stacked_previews']"
        ) ||
        elem.querySelector(".product__media-list[data-desktop-type='stacked']");

      if (stackedList && window.innerWidth >= 990) {
        const targetItem = stackedList.querySelector(
          `[data-media-id="${targetMediaId}"]`
        );

        if (targetItem) {
          const offset =
            targetItem.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: offset - 100,
            behavior: "smooth",
          });
        }
      }
    });

    /**
     * ------------------------------------------------
     * Quick view
     * ------------------------------------------------
     */

    const swiperWrappersQuickView = scopedContainer.querySelectorAll(
      ".quick-product__media-list"
    );

    swiperWrappersQuickView.forEach((elem) => {
      if (this.isHidden(elem)) return;

      const newMedia = elem.querySelector(`[data-media-id="${targetMediaId}"]`);

      if (!newMedia) return;

      const mediaList = elem.querySelector(".quick-js-media-list");

      if (mediaList && mediaList.swiper) {
        let slideIndex = mediaList.swiper.slides.findIndex((slideEl) => {
          return slideEl.dataset?.mediaId === targetMediaId;
        });

        if (slideIndex === -1) {
          slideIndex = Number(newMedia.dataset?.swiperSlideIndex || 0);
        }

        mediaList.swiper.slideTo(slideIndex, 800);
      } else {
        newMedia && parent.prepend(newMedia);

        window.setTimeout(() => {
          parent.scroll(0, 0);
        });
      }
    });
    window.dispatchEvent(new Event("resize"));
  }

  // updateMedia(mediaId) {
  // 	if (!mediaId) return

  // 	const mediaEl = document.querySelector(
  // 		`[data-section="product-media-${this.dataset.section}"]`,
  // 	)
  // 	if (!mediaEl) return

  // 	// for slider and slider_previews layout
  // 	const sliderEl = mediaEl.querySelector('.js-media-list')
  // 	if (sliderEl && sliderEl.swiper) {
  // 		sliderEl.querySelectorAll('.swiper-slide').forEach((slide, index) => {
  // 			const slideMediaId = slide.dataset?.mediaId
  // 			if (slideMediaId === mediaId) {
  // 				const findIndex = sliderEl.swiper.slides.findIndex((slideEl) => {
  // 					return slideEl.dataset?.mediaId === slideMediaId
  // 				})
  // 				const fallbackIndex = Number(slide.dataset?.swiperSlideIndex || index)
  // 				const swiperSlideIndex = findIndex !== -1 ? findIndex : fallbackIndex
  // 				sliderEl.swiper.slideTo(swiperSlideIndex, 800)
  // 			}
  // 		})
  // 	}

  // 	// for stacked_previews layout
  // 	const stackedEl =
  // 		mediaEl.querySelector(
  // 			".product__media-list[data-desktop-type='stacked_previews']",
  // 		) ||
  // 		mediaEl.querySelector(".product__media-list[data-desktop-type='stacked']")
  // 	if (stackedEl && window.innerWidth >= 990) {
  // 		stackedEl.querySelectorAll('[data-media-id]').forEach((mediaItem) => {
  // 			const mediaItemId = mediaItem.dataset?.mediaId
  // 			if (mediaItemId === mediaId) {
  // 				const offset = mediaItem.getBoundingClientRect().top + window.scrollY
  // 				window.scrollTo({top: offset - 100, behavior: 'smooth'})
  // 			}
  // 		})
  // 	}
  // }

  updateURL() {
    if (!this.closest(".quick-add-modal__content-wrapper")) {
      if (this.dataset.updateUrl === "false") return;
      let basePath =
        this.combinedProductURL || this.dataset.url || window.location.pathname;

      if (basePath.includes("?")) {
        basePath = basePath.split("?")[0];
      }

      const newUrl = this.currentVariant
        ? `${basePath}?variant=${this.currentVariant.id}`
        : basePath;

      window.history.replaceState({}, "", newUrl);
    }
  }

  updateVariantInput() {
    const scopedContainer = this.getScopedContainer();

    const productForms = scopedContainer.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.options[0]
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant.options[index - 1] === previousOptionSelected
        )
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];

    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;

      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];

      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }

  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    const selectedValues = controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    });

    return selectedValues;
  }

  isFloatedPicker() {
    return this.dataset.section?.startsWith("floated-");
  }

  getMainSectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }

  getCounterpartPicker() {
    const mainSectionId = this.getMainSectionId();

    if (this.isFloatedPicker()) {
      return document.getElementById(`variant-picker-${mainSectionId}`);
    }

    return document.querySelector(
      `floated-form #variant-picker-floated-${mainSectionId}`
    );
  }

  updateFloatedDropdownLabels(picker) {
    picker
      .querySelectorAll(".product-form__controls--dropdown")
      .forEach((fieldset) => {
        const selectLabel = fieldset.querySelector(
          ".select-wrapper > .select-label, .dropdown-select > .select-label"
        );
        const span = selectLabel?.querySelector("span");
        const checked = fieldset.querySelector('input[type="radio"]:checked');

        if (!span || !checked) return;

        const label = fieldset.querySelector(`label[for="${checked.id}"]`);
        const selectedValue =
          label
            ?.querySelector(".pills-variant-labels-text, .select-label")
            ?.textContent.trim() ||
          label?.textContent.trim() ||
          checked.value;

        span.textContent = selectedValue;
        span.setAttribute("title", selectedValue);
      });
  }

  syncInputDisabledStates(sourcePicker, targetPicker) {
    const sourceGroups = [
      ...sourcePicker.querySelectorAll(".product-form__controls"),
    ];
    const targetGroups = [
      ...targetPicker.querySelectorAll(".product-form__controls"),
    ];

    sourceGroups.forEach((sourceGroup, index) => {
      const targetGroup = targetGroups[index];
      if (!targetGroup) return;

      sourceGroup
        .querySelectorAll('input[type="radio"]')
        .forEach((sourceInput) => {
          const targetInput = [
            ...targetGroup.querySelectorAll('input[type="radio"]'),
          ].find((input) => input.value === sourceInput.value);

          if (!targetInput) return;

          targetInput.classList.toggle(
            "disabled",
            sourceInput.classList.contains("disabled")
          );
          targetInput.disabled = sourceInput.disabled;
        });
    });
  }

  applySyncToPicker(counterpart, selectedValues, html) {
    if (!counterpart || counterpart === this) return;

    const mainSectionId = this.getMainSectionId();
    const isFloatedTarget = counterpart.isFloatedPicker?.()
      ? counterpart.isFloatedPicker()
      : counterpart.dataset.section?.startsWith("floated-");

    counterpart._syncingFromCounterpart = true;

    try {
      counterpart.setCheckedInputsBySelectedValues(selectedValues);
      this.syncInputDisabledStates(this, counterpart);

      if (isFloatedTarget) {
        this.updateFloatedDropdownLabels(counterpart);
      }

      counterpart.currentVariant = this.currentVariant;

      const variantPickerSource = html.getElementById(
        `variant-picker-${mainSectionId}`
      );
      const selectedVariantScript = variantPickerSource?.querySelector(
        "[data-selected-variant]"
      );
      const counterpartVariantScript = counterpart.querySelector(
        "[data-selected-variant]"
      );

      if (selectedVariantScript && counterpartVariantScript) {
        counterpartVariantScript.innerHTML = selectedVariantScript.innerHTML;
      }

      const targetSectionId = isFloatedTarget
        ? `floated-${mainSectionId}`
        : mainSectionId;
      const productForm = document.getElementById(
        `product-form-${targetSectionId}`
      );
      const variantInput = productForm?.querySelector('input[name="id"]');

      if (variantInput && this.currentVariant) {
        variantInput.value = this.currentVariant.id;
      }

      const priceSource = html.getElementById(`price-${mainSectionId}`);

      if (priceSource) {
        const priceDestination = isFloatedTarget
          ? document.getElementById(`price-floated-${mainSectionId}`)
          : document.getElementById(`price-${mainSectionId}`);

        if (priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
          priceDestination.classList.remove("visibility-hidden");
        }
      }

      if (this.currentVariant) {
        counterpart.toggleAddButtonForSection(
          targetSectionId,
          !this.currentVariant.available,
          !this.currentVariant.available ? window.variantStrings.soldOut : ""
        );
      }
    } finally {
      counterpart._syncingFromCounterpart = false;
    }
  }

  syncFloatedFormCounterpart(html) {
    const counterpart = this.getCounterpartPicker();
    if (!counterpart) return;

    this.applySyncToPicker(counterpart, this.getSelectedValues(), html);
  }

  updatePickupAvailability() {
    const scopedContainer = this.getScopedContainer();

    const pickUpAvailability = scopedContainer.querySelector(
      "pickup-availability"
    );
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (
                this.currentVariant.featured_media &&
                this.dataset?.variantMediaDisplay === "show_all"
              ) {
                // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
                const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
                this.updateMedia(mediaId);
              }
            }
          } catch (err) {}
        }
        // -----

        this.updateElementsAfterFetch(html);

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  toggleAddButton(disable = true, text) {
    this.toggleAddButtonForSection(this.dataset.section, disable, text);
  }

  toggleAddButtonForSection(sectionId, disable = true, text) {
    const productForms = document.querySelectorAll(
      `#product-form-${sectionId}, #product-form-installment-${sectionId}`
    );
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const notifyButton = document.getElementById(
        `notify-button-${sectionId}`
      );

      if (!addButton) return;

      const addButtonText =
        addButton.querySelector(".button__label") ||
        addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        if (text) {
          addButtonText.textContent = text;
          notifyButton?.setAttribute("disabled", "disabled");

          if (text === window.variantStrings.unavailable) {
            addButton.dataset.status = "unavailable";
          } else {
            addButton.dataset.status = "sold-out";
          }
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
        addButton.dataset.status = "available";
        notifyButton?.removeAttribute("disabled");
      }
    });
  }

  resetErrorMessage() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  setUnavailable() {
    const scopedContainer = this.getScopedContainer();
    const price = scopedContainer.querySelector(
      `price-${this.dataset.section}`
    );
    const priceSticky = scopedContainer.querySelector(
      `price-sticky-${this.dataset.section}`
    );
    const button = scopedContainer.querySelector(
      `#product-form-${this.dataset.section}`
    );
    const inventory = scopedContainer.querySelector(
      `#Inventory-${this.dataset.section}`
    );
    const pickerInventory = scopedContainer.querySelector(
      `#PickerInventory-${this.dataset.section}`
    );
    const sku = scopedContainer.querySelector(`#Sku-${this.dataset.section}`);
    const colorNameDestinations = scopedContainer.querySelectorAll(
      `[id^="ColorName-${this.dataset.section}"]`
    );
    const addButtonText = button.querySelectorAll('[name="add"] > span');

    addButtonText.forEach((elem) => {
      elem.innerHTML = `${window.variantStrings.unavailable}`;
    });
    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (pickerInventory) pickerInventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-all-variants-no-high]").textContent);
    return this.variantData;
  }

  // Main function
  updateElementsAfterFetch(html) {
    const scopedContainer = this.getScopedContainer();
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    // price
    const priceDestination = scopedContainer.querySelector(
      `#price-${currentSectionId}`
    );
    const priceStickyDestination = scopedContainer.querySelector(
      `#price-sticky-${currentSectionId}`
    );
    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }
    if (priceSource && priceStickyDestination) {
      priceStickyDestination.innerHTML = priceSource.innerHTML;
      const priceText = priceStickyDestination.querySelector(".price-text");
      if (priceText) priceText.className = "price-text";
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = scopedContainer.querySelector(
      `#Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }

    const pickerInventorySource = html.getElementById(
      `PickerInventory-${sourceSectionId}`
    );
    const pickerInventoryDestination = scopedContainer.querySelector(
      `#PickerInventory-${currentSectionId}`
    );
    if (pickerInventorySource && pickerInventoryDestination) {
      pickerInventoryDestination.innerHTML = pickerInventorySource.innerHTML;
      pickerInventoryDestination.classList.toggle(
        "visibility-hidden",
        pickerInventorySource.innerText === ""
      );
    }

    // sku
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = scopedContainer.querySelector(
      `#Sku-${currentSectionId}`
    );
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = scopedContainer.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    if (
      this.isCombinedListingsNeedUpdate &&
      this.closest(".featured-product")
    ) {
      const productInfoSource = html.getElementById(
        `ProductInfo-${sourceSectionId}`
      );
      const productInfoDestination = scopedContainer.querySelector(
        `#ProductInfo-${currentSectionId}`
      );

      if (productInfoSource && productInfoDestination) {
        const descriptionSource = productInfoSource.querySelector(
          ".product__text.medium-font"
        );
        const descriptionDestination = productInfoDestination.querySelector(
          ".product__text.medium-font"
        );

        if (descriptionSource && descriptionDestination) {
          descriptionDestination.innerHTML = descriptionSource.innerHTML;
        }
      }
    }

    if (this.isHighVariantNeedUpdate !== true && !this.isFloatedPicker()) {
      const variantSwatchesSource = html.querySelector(
        `#variant-picker-${sourceSectionId} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = scopedContainer.querySelector(
        `#variant-picker-${currentSectionId} [data-is-variant-image-swatch="true"]`
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        const quickViewModal = this.closest("quick-add-modal");
        if (quickViewModal) {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML.replaceAll(
              sourceSectionId,
              `quickview-${sourceSectionId}`
            );
        } else {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML;
        }
      }
    }

    // product media
    if (
      this.dataset?.variantMediaDisplay !== "show_all" ||
      this.isCombinedListingsNeedUpdate
    ) {
      const parentQuickView = this.closest("quick-add-modal");
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = scopedContainer.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );

      if (mediaSource && mediaDestination) {
        // --- 1. PRODUCT MODAL (GLOBAL TARGET + DUPLICATION PURGE) ---
        const modalSourceContent = html.querySelector(
          `#ProductModal-${sourceSectionId} .product-media-modal__content`
        );
        const modalDestinationContent = document.querySelector(
          `#ProductModal-${currentSectionId} .product-media-modal__content`
        );

        // Quick view must not touch page-level product modal content.
        if (!parentQuickView && modalSourceContent && modalDestinationContent) {
          const existingSwiper =
            modalDestinationContent.querySelector(".swiper")?.swiper;
          if (existingSwiper) {
            existingSwiper.destroy(true, true);
          }

          modalDestinationContent.innerHTML = modalSourceContent.innerHTML;

          // PURGE DUPLICATED FORM DETAILS: Keeps your modal strictly focused on images
          modalDestinationContent
            .querySelectorAll(
              ".product__info-wrapper, .product__left-wrapper, .product-form, .price, .product__title"
            )
            .forEach((duplicatedBlock) => {
              duplicatedBlock.remove();
            });
        }

        // Copy over all dataset tracking values from source to destination wrapper
        // This ensures swatch scripts read the fresh variant relationship rules!
        if (mediaSource.dataset) {
          Object.keys(mediaSource.dataset).forEach((key) => {
            mediaDestination.dataset[key] = mediaSource.dataset[key];
          });
        }

        // Copy any class updates applied by high-variant rules
        if (!parentQuickView) {
          mediaDestination.className = mediaSource.className;
        }

        // Safely update the inner HTML structural layout without breaking node associations
        mediaDestination.innerHTML = mediaSource.innerHTML;

        // --- 3. RE-INITIALIZE THE SLIDERS & INTERACTIVE PLUGINS ---
        // Scope to scopedContainer so only the updated section's sliders are
        // re-initialized; prevents spill-over into the main product or other
        // unrelated product sections on the same page.
        quickSliderInit(true, scopedContainer);

        if (!parentQuickView) {
          sliderInit(true, scopedContainer);
        }

        const parentFeaturedProduct = this.closest(".featured-product");

        if (parentQuickView) {
          if (typeof parentQuickView.removeDOMElements === "function") {
            parentQuickView.removeDOMElements(mediaDestination);
          }
          if (typeof parentQuickView.initSlider === "function") {
            parentQuickView.initSlider();
          }
        } else if (parentFeaturedProduct) {
          const featuredSection = document.getElementById(
            `shopify-section-${currentSectionId}`
          );

          if (
            featuredSection &&
            typeof window.initFeaturedProduct === "function"
          ) {
            window.initFeaturedProduct(featuredSection);
          }
        } else {
          const mainSection = document.getElementById(
            `shopify-section-${currentSectionId}`
          );

          if (mainSection && typeof initProductPage === "function") {
            initProductPage(mainSection);
          }
        }
      }
    }

    // Update elements for B2B quantity pricing https://help.shopify.com/en/manual/b2b/catalogs/quantity-pricing
    const productButtonsSource = html.querySelector(
      `[data-id="ProductButtons-${sourceSectionId}"]`
    );
    const productButtonsDestination = document.querySelectorAll(
      `[data-id="ProductButtons-${currentSectionId}"]`
    );
    if (productButtonsSource) {
      const sourceButtonsWrapper = productButtonsSource;
      productButtonsDestination.forEach((el) => {
        const buttonsWrapper = el;

        if (sourceButtonsWrapper && buttonsWrapper) {
          const sourceHasQuantityPricing =
            sourceButtonsWrapper.dataset.hasQuantityPricing === "true";
          const destHadQuantityPricing =
            buttonsWrapper.dataset.hasQuantityPricing === "true";

          if (sourceHasQuantityPricing || destHadQuantityPricing) {
            if (sourceHasQuantityPricing) {
              buttonsWrapper.dataset.hasQuantityPricing = "true";
            } else {
              buttonsWrapper.removeAttribute("data-has-quantity-pricing");
            }

            const sourceB2bEl = sourceButtonsWrapper.querySelector(
              ".product-b2b-elements"
            );
            const destB2bEl = buttonsWrapper.querySelector(
              ".product-b2b-elements"
            );
            if (sourceB2bEl && destB2bEl) {
              destB2bEl.innerHTML = sourceB2bEl.innerHTML;
            } else if (sourceB2bEl && !destB2bEl) {
              buttonsWrapper.insertAdjacentHTML(
                "afterbegin",
                sourceB2bEl.outerHTML
              );
            } else if (!sourceB2bEl && destB2bEl) {
              destB2bEl.remove();
            }

            const sourceVolumeNote = sourceButtonsWrapper.querySelector(
              ".product__volume-pricing-note"
            );
            const destVolumeNote = buttonsWrapper.querySelector(
              ".product__volume-pricing-note"
            );
            if (sourceVolumeNote && destVolumeNote) {
              destVolumeNote.innerHTML = sourceVolumeNote.innerHTML;
            } else if (sourceVolumeNote && !destVolumeNote) {
              const b2bEl = buttonsWrapper.querySelector(".product-b2b-elements");
              const insertAfter = b2bEl || buttonsWrapper.firstElementChild;
              if (insertAfter) {
                insertAfter.insertAdjacentHTML("afterend", sourceVolumeNote.outerHTML);
              }
            } else if (!sourceVolumeNote && destVolumeNote) {
              destVolumeNote.remove();
            }

            const sourceQuantityWrapper = sourceButtonsWrapper.querySelector(
              ".product-form__quantity"
            );
            const destQuantityWrapper = buttonsWrapper.querySelector(
              ".product-form__quantity"
            );
            if (sourceQuantityWrapper && destQuantityWrapper) {
              destQuantityWrapper.innerHTML = this.dataset.originalSection
                ? sourceQuantityWrapper.innerHTML.replaceAll(sourceSectionId, currentSectionId)
                : sourceQuantityWrapper.innerHTML;
            }
          }
        }
      });
    }

    this.syncFloatedFormCounterpart(html);
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );

    const scopedContainer = this.getScopedContainer();

    const variantPickerDestionation = scopedContainer.querySelector(
      `#variant-picker-${this.dataset.section}`
    );

    variantPickerDestionation.dataset.updateUrl =
      variantPickerSource.dataset.updateUrl;

    if (!variantPickerSource) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestionation.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );

    const scopedContainer = this.getScopedContainer();

    const variantPickerDestination = scopedContainer.querySelector(
      `#variant-picker-${currentSectionId}`
    );

    if (variantPickerSource && variantPickerDestination) {
      const quickViewModal = this.closest("quick-add-modal");
      if (quickViewModal) {
        variantPickerDestination.innerHTML =
          variantPickerSource.innerHTML.replaceAll(
            sourceSectionId,
            `quickview-${sourceSectionId}`
          );
      } else {
        variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
      }
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
        input.disabled = false;
      } else {
        input.classList.add("disabled");
        //input.disabled = true;
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );

    const $this = this;

    this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
      "click",
      function () {
        if (
          $this
            .closest(".swiper")
            .swiper.slides[
              $this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
        ) {
          if (
            !$this
              .closest(".swiper")
              .swiper.slides[
                $this.closest(".swiper").swiper.activeIndex
              ].querySelector("model-viewer")
              .classList.contains("shopify-model-viewer-ui__disabled")
          ) {
            if (
              $this
                .querySelector(".shopify-model-viewer-ui__button")
                .hasAttribute("hidden")
            ) {
              $this.closest(".swiper").swiper.params.noSwiping = true;
              $this.closest(".swiper").swiper.params.noSwipingClass =
                "swiper-slide";
            }
          }
        }
      }
    );

    this.querySelector(
      ".shopify-model-viewer-ui__controls-overlay"
    ).addEventListener("click", function () {
      if (
        !$this
          .querySelector(".shopify-model-viewer-ui__button")
          .hasAttribute("hidden")
      ) {
        $this.closest(".swiper").swiper.params.noSwiping = false;
      }
    });
  }
}
customElements.define("product-model", ProductModel);

(function () {
  const hoverOpacity = () => {
    $("[data-hover-opacity]").hover(
      function () {
        const id = $(this).data("hover-opacity");
        $(`[data-hover-opacity=${id}]`).addClass("opacity");
        $(this).removeClass("opacity");
      },
      function () {
        const id = $(this).data("hover-opacity");
        $(`[data-hover-opacity=${id}]`).removeClass("opacity");
      }
    );
  };
  document.addEventListener("DOMContentLoaded", function () {
    hoverOpacity();
    document.addEventListener("shopify:section:load", function () {
      hoverOpacity();
    });
  });
})();
(function () {
  const sidebar = () => {
    let pageNav = $(".product-details");

    if (pageNav.length > 0) {
      let pageNavList = pageNav.find("a");
      let adminBarHeight = 0;

      let headings = [];
      for (let i = 0; i < pageNavList.length; i++) {
        headings[i] = $($(pageNavList[i]).attr("href"));
      }

      $(pageNavList[0]).addClass("active");

      $(window).on("scroll", function () {
        for (let i = headings.length; i >= 0; i--) {
          if ($(headings[i]).length > 0) {
            if (
              $(headings[i]).offset().top - 50 <=
              $(window).scrollTop() + adminBarHeight
            ) {
              if (!$(pageNavList[i]).hasClass("active")) {
                let hasActiveItem = false;
                for (let j = i; j < headings.length; j++) {
                  if ($(pageNavList[j]).hasClass("active")) {
                    hasActiveItem = true;
                  }
                }

                if (!hasActiveItem) {
                  $(pageNavList[i]).addClass("active");
                  if ($(pageNavList[i]).hasClass("product-details-nav-item")) {
                  }

                  history.pushState(
                    null,
                    null,
                    window.location.origin +
                      window.location.pathname +
                      $(pageNavList[i]).attr("href")
                  );
                }
              } else {
                for (let j = 0; j < i; j++) {
                  $(pageNavList[j]).removeClass("active");
                }
              }
            } else {
              if (i !== 0) {
                $(pageNavList[i]).removeClass("active");
              }
            }
          }
        }
      });
    }
  };
  document.addEventListener("DOMContentLoaded", function () {
    sidebar();
    document.addEventListener("shopify:section:load", function () {
      sidebar();
    });
  });
})();

(function () {
  const initDrawerAccordion = () => {
    $(".drawer__accordion-title").click(function () {
      if ($(this).hasClass("second_level")) {
        //$(this).toggleClass('active')
        const isActive = $(this).hasClass("active");
        $(".drawer__accordion-title.second_level").removeClass("active");
        if (!isActive) {
          $(this).addClass("active");
        }
      } else {
        if (!$(this).hasClass("active")) {
          $(".drawer__accordion-title.first_level.active").removeClass(
            "active"
          );
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initDrawerAccordion();
    document.addEventListener("shopify:section:load", function () {
      initDrawerAccordion();
    });
  });
})();

(function () {
  const textAnimation = () => {
    const elements = document.querySelectorAll('[data-animation-text="true"]');

    elements.forEach((element) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(element);
            animateText(element);
          }
        });
      });

      observer.observe(element);
    });
  };

  const animateText = (element) => {
    const word = element.textContent.trim();
    element.innerHTML = "";

    const charsArray = [];
    for (let char of word) {
      if (char === " ") {
        element.appendChild(document.createTextNode(" "));
      } else {
        const span = document.createElement("span");
        span.className = "char";
        span.textContent = char;
        element.appendChild(span);
        charsArray.push(span);
      }
    }

    gsap.set(element, { opacity: 1 });
    shuffleArray(charsArray);

    let delay = 0.1;
    charsArray.forEach((char, index) => {
      gsap.to(char, {
        opacity: 1,
        duration: 0.5,
        delay: delay * index,
        ease: "power3.out",
      });
    });

    gsap.to(element, {
      opacity: 1,
      duration: 0.5,
      delay: delay * word.length,
      ease: "power3.out",
    });
  };

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    textAnimation();
  });

  document.addEventListener("shopify:section:load", function () {
    textAnimation();
  });
})();

function buttonHoverEffects() {
  function wrapLetters(element) {
    if (element.dataset.hoverstaggerReady === "true") {
      return;
    }

    const text = element.textContent.trim();
    element.innerHTML = "";
    const words = text.split(" ");
    words.forEach((word, index) => {
      const wordSpan = document.createElement("span");
      for (let char of word) {
        const charSpan = document.createElement("span");
        charSpan.className = "char";
        charSpan.textContent = char;
        wordSpan.appendChild(charSpan);
      }
      element.appendChild(wordSpan);
      if (index < words.length - 1) {
        element.appendChild(document.createTextNode(" "));
      }
    });

    element.dataset.hoverstaggerReady = "true";
  }

  document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);

  document
    .querySelectorAll(".button, .button-animation")
    .forEach(function (button) {
      if (button.dataset.buttonHoverReady === "true") {
        return;
      }

      let link = button.querySelector("[hoverstagger='link']");
      if (!link) return;

      let text1 = link.querySelectorAll("[hoverstagger='text']")[0];
      let text2 = link.querySelectorAll("[hoverstagger='text']")[1];

      if (!text1 || !text2) return;

      const text1Chars = text1.querySelectorAll(".char");
      const text2OddChars = text2.querySelectorAll(".char:nth-child(odd)");
      const text2EvenChars = text2.querySelectorAll(".char:nth-child(even)");

      gsap.set(text1Chars, { yPercent: 0 });
      gsap.set(text2OddChars, { yPercent: -100 });
      gsap.set(text2EvenChars, { yPercent: 100 });

      let tl = gsap.timeline({
        paused: true,
        defaults: {
          duration: 0.7,
          ease: "power2.out",
        },
      });

      tl.fromTo(
        text1.querySelectorAll(".char:nth-child(odd)"),
        { yPercent: 0 },
        { yPercent: 100 }
      );
      tl.fromTo(text2OddChars, { yPercent: -100 }, { yPercent: 0 }, 0);
      tl.fromTo(
        text1.querySelectorAll(".char:nth-child(even)"),
        { yPercent: 0 },
        { yPercent: -100 },
        0
      );
      tl.fromTo(text2EvenChars, { yPercent: 100 }, { yPercent: 0 }, 0);

      button.addEventListener("mouseenter", function () {
        if (
          window.innerWidth > 768 &&
          button.getAttribute("aria-disabled") !== "true"
        ) {
          tl.restart();
        }
      });

      button.dataset.buttonHoverReady = "true";
    });
}

document.addEventListener("DOMContentLoaded", buttonHoverEffects);
document.addEventListener("shopify:section:load", buttonHoverEffects);

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  cents = parseInt(cents, 10);

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = precision > 0 ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  const formatType = match ? match[1] : "amount";

  switch (formatType) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
}

(function () {
  const selectDropDown = () => {
    // Only target dropdowns that haven't been initialized yet
    const dropdowns = document.querySelectorAll(
      ".product-form__controls--dropdown:not([data-initialized])"
    );

    dropdowns.forEach((container) => {
      const dropdownSelect = container.querySelector(".dropdown-select");
      const elList = dropdownSelect?.querySelector("ul");
      const elListItems = dropdownSelect?.querySelectorAll("ul li") || [];
      const selectedText =
        dropdownSelect?.querySelector(".select-wrapper > .select-label") ||
        dropdownSelect?.querySelector(":scope > .select-label");
      const shadowTop = container.querySelector(".shadow-top");
      const shadowBottom = container.querySelector(".shadow-bottom");

      if (!elList || !selectedText) return;

      container.setAttribute("data-initialized", "true");

      const updateShadows = () => {
        shadowTop?.classList.toggle("show", elList.scrollTop > 0);
        shadowBottom?.classList.toggle(
          "show",
          elList.scrollTop + elList.clientHeight < elList.scrollHeight - 5
        );
      };

      selectedText.addEventListener("click", function (e) {
        e.stopPropagation();
        const isActive = elList.classList.contains("active");

        // Close other open dropdowns
        document
          .querySelectorAll(".dropdown-select ul.active")
          .forEach((openUl) => {
            if (openUl !== elList) openUl.classList.remove("active");
          });

        elList.classList.toggle("active");
        if (elList.classList.contains("active")) updateShadows();
      });

      elListItems.forEach((li) => {
        li.addEventListener("click", function () {
          const input = li.querySelector('input[type="radio"]');
          const isNotifyMe = li
            .querySelector(".pills-variant-labels")
            ?.classList.contains("notify_me");

          if ((input && !input.classList.contains("disabled")) || isNotifyMe) {
            if (
              input &&
              !input.classList.contains("disabled") &&
              !input.checked
            ) {
              input.checked = true;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }

            const span = selectedText.querySelector("span");
            if (span) {
              const selectLabelSpan = li.querySelector(".select-label");
              const pillsLabel = li.querySelector(".pills-variant-labels-text");
              const selectedValue =
                selectLabelSpan?.textContent.trim() ||
                pillsLabel?.textContent.trim() ||
                li.innerText.trim();
              span.textContent = selectedValue;
              span.setAttribute("title", selectedValue);
            }
            if (li.dataset.color) {
              selectedText.style.setProperty(
                "--swatch-color",
                li.dataset.color
              );
            }
          }
          elList.classList.remove("active");
        });
      });

      elList.addEventListener("scroll", updateShadows);
    });
  };

  // 1. Initial Load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", selectDropDown);
  } else {
    selectDropDown();
  }

  // 2. Global click to close
  document.addEventListener("click", () => {
    document
      .querySelectorAll(".dropdown-select ul.active")
      .forEach((ul) => ul.classList.remove("active"));
  });

  // 3. Shopify Theme Editor Support
  document.addEventListener("shopify:section:load", selectDropDown);

  // 4. THE FIX: Watch for AJAX/Internal page refreshes
  // This observes the body for any added elements and re-runs the init logic
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        selectDropDown();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.initVariantDropdowns = selectDropDown;
})();

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".cart-items-wrapper" },
    { id: "main-cart-footer", selector: ".cart__footer" },
    { id: "main-cart-shipping", selector: ".cart-shipping" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});

// CART REFRESH EVENT END

function addFirefoxMacClass() {
  const isFirefox = navigator.userAgent.includes("Firefox");
  const isMac = navigator.userAgent.includes("Mac");

  if (isFirefox && isMac) {
    document.documentElement.classList.add("firefox-mac");
  }
}

addFirefoxMacClass();
